var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgILoadCapacity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6249 2.5H4.37488C3.8776 2.5 3.40068 2.69754 3.04905 3.04917C2.69742 3.40081 2.49988 3.87772 2.49988 4.375V25.625C2.49988 26.1223 2.69742 26.5992 3.04905 26.9508C3.40068 27.3025 3.8776 27.5 4.37488 27.5H25.6249C26.1222 27.5 26.5991 27.3025 26.9507 26.9508C27.3023 26.5992 27.4999 26.1223 27.4999 25.625V4.375C27.4999 3.87772 27.3023 3.40081 26.9507 3.04917C26.5991 2.69754 26.1222 2.5 25.6249 2.5V2.5Z",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49988 11.9088C9.578 9.40875 12.078 8.15875 14.9999 8.15875C17.9218 8.15875 20.4218 9.40875 22.4999 11.9088",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 19.375C15.4972 19.375 15.9741 19.1775 16.3257 18.8258C16.6773 18.4742 16.8749 17.9973 16.8749 17.5C16.8749 17.0027 16.6773 16.5258 16.3257 16.1742C15.9741 15.8225 15.4972 15.625 14.9999 15.625C14.5026 15.625 14.0257 15.8225 13.6741 16.1742C13.3224 16.5258 13.1249 17.0027 13.1249 17.5C13.1249 17.9973 13.3224 18.4742 13.6741 18.8258C14.0257 19.1775 14.5026 19.375 14.9999 19.375V19.375Z",
    fill: "#262626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 13.125L15.005 17.5",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgILoadCapacity);
export default __webpack_public_path__ + "static/media/iLoadCapacity.226828682569a5390b4323aebd758388.svg";
export { ForwardRef as ReactComponent };